/* eslint-disable max-len */
import React from 'react';
import { ReactComponent as PositionIcon } from '../../../../assets/icons/position.svg';
import { ReactComponent as CandidateIcon } from '../../../../assets/icons/candidates.svg';
import { ReactComponent as ReferenceIcon } from '../../../../assets/icons/reference.svg';
import { ReactComponent as SurveyIcon } from '../../../../assets/icons/survey.svg';

export enum RequestBuilderPage {
  Step1 = 'position',
  Step2 = 'candidates',
  Step3 = 'references',
  Step4 = 'survey',
  Step5 = 'review'
}

export const getIcon = (step: RequestBuilderPage) => {
  switch (step) {
    case RequestBuilderPage.Step1:
      return <PositionIcon />;
    case RequestBuilderPage.Step2:
      return <CandidateIcon />;
    case RequestBuilderPage.Step3:
      return <ReferenceIcon />;
    case RequestBuilderPage.Step4:
      return <SurveyIcon />;
    default:
      return null;
  }
};

export const steps = [
  RequestBuilderPage.Step1,
  RequestBuilderPage.Step2,
  RequestBuilderPage.Step3,
  RequestBuilderPage.Step4,
  RequestBuilderPage.Step5
];
